import React from 'react';
import AppRoutes from './routes';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import { NotificationProvider } from './context/NotificationContext';

const App = () => (
  <Router>
    <AuthProvider>
      <SettingsProvider>
        <NotificationProvider>
          <AppRoutes />
        </NotificationProvider>
      </SettingsProvider>
    </AuthProvider>
  </Router>
);

export default App;
